<template>
  <Card
    :class="{ error: calculateErrorCard, disabled: disabled }"
    test-id="Resumen"
    class="borderShadow"
    tabindex="0"
  >
    <template #title>
      <div
        class="title flex justify-content-between flex-wrap cursor-pointer"
        @click="triggerAddMethod(editPath)"
      >
        <div test-id="ResumenTitle" class="text-gray-700 font-medium text-xl">
          {{ title }}
        </div>
        <Button
          icon="pi pi-plus"
          v-if="showPlusButton"
          ref="cardFocus"
          class="p-button-rounded p-button-info p-button-outlined text-gray-500"
          :disabled="disabled"
          @click="triggerAddMethod(editPath)"
          :test-id="title + 'AddButton'"
        />
      </div>
    </template>
    <template #content>
      <slot></slot>
    </template>
  </Card>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";

// Props
const props = defineProps({
  showPlusButton: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
  title: { type: String, default: null },
  editPath: { type: String, default: null },
  warning: { type: [String, Array] },
  errors: { type: [String, Array] },
  formType: { type: String, default: null },
  showValidation: { type: Boolean, default: false },
  viewData: { type: Object },
  detectedError: { type: Boolean, default: false },
});

// Emits
const emit = defineEmits(["disableAfectation", "disablePersonsAndEffect"]);

const router = useRouter();
const cardFocus = ref(null);

function triggerAddMethod(editPath) {
  if (
    props.title === "Aprehendido y/o acusado" ||
    props.title === "Efectos" ||
    props.title === "Víctima y/o damnificado"
  ) {
    emit("disableAfectation");
    router.push({ path: editPath, query: { id: "new" } });
  } else if (props.title === "Afectación Patrimonial") {
    router.push({ path: editPath, query: { id: "new" } });
    emit("disablePersonsAndEffect");
  } else {
    router.push({ path: editPath, query: { id: "new" } });
  }
}

function alertas() {
  if (props.disabled) return null;

  const warning = Array.isArray(props.warning) ? props.warning : [props.warning];
  const errors = Array.isArray(props.errors) ? props.errors : [props.errors];

  if (props.title === "Acusado" && !warning.includes("No especificó un acusado")) return "ok";
  if (props.title === "Contraventor/a" && !warning.includes("No especificó un acusado"))
    return "ok";
  if (
    props.title === "Vinculados" &&
    !errors.includes("Falta especificar un acusado") &&
    !warning.includes("No especificó un acusado")
  )
    return "ok";
  if (
    props.title === "Autolesionado" &&
    !errors.includes("Debe especificar al menos un Autolesionado")
  )
    return "ok";
  if (
    (props.title === "Efectos secuestrados" || props.title === "Efectos") &&
    !warning.includes("No especificó ningún efecto denunciado")
  )
    return "ok";
  if (props.title === "Causante" && !errors.includes("Falta especificar un causante")) return "ok";

  return "false";
}

const calculatePassedCard = computed(() => {
  if (props.disabled) return null;
  return props.viewData?.resumenCardPassed && alertas() === "ok" && props.showValidation === true;
});

const calculateWarningCard = computed(() => {
  if (props.disabled) return null;
  return (
    alertas() !== "ok" &&
    props.showValidation === true &&
    (props.viewData?.resumenCardWarning === true ||
      (props.formType?.startsWith("ufi") &&
        (props.title === "Efectos secuestrados" || props.title === "Efectos")))
  );
});

const calculateErrorCard = computed(() => {
  if (props.disabled) return null;
  if (props.detectedError) return true;

  return (
    alertas() !== "ok" &&
    props.showValidation === true &&
    (props.formType?.startsWith("ufi") ||
      (props.formType === "preliminar-tentativa-suicidio" && props.title === "Autolesionado") ||
      (props.formType === "preliminar-fuga-menor" && props.title === "Causante")) &&
    !(props.title === "Efectos secuestrados" || props.title === "Efectos")
  );
});
</script>

<style scoped>
.content {
  width: 100%;
}
div.card {
  width: 100%;
}
.borderShadow:focus {
  box-shadow: 0 0 0 0.2rem #89d4fe;
  outline: none;
}
.title {
  font-size: 1rem;
}
.title-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.passed {
  border-bottom: solid 2px #28a745;
  /* background-color: #28a745; */
}
.error {
  border-bottom: solid 2px #dc3545;
}
.warning {
  border-bottom: solid 2px #ffc107;
}
.alert {
  color: #dc3545;
}
.disabled {
  pointer-events: none;
  filter: brightness(0.9);
}
</style>
